module.exports = __webpack_public_path__ + "img/bg_bg.2728f201.png";